import { resolveComponent as u, openBlock as t, createElementBlock as r, createElementVNode as s, normalizeClass as a, renderSlot as d, toDisplayString as f, createCommentVNode as l, createBlock as m } from "vue";
import { _ as c } from "./_plugin-vue_export-helper-dad06003.js";
import { C as _ } from "./CheckIcon-91388c05.js";
const x = {
  name: "DropdownItem",
  components: {
    CheckIcon: _
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    isDanger: {
      type: Boolean,
      default: !1
    }
  }
}, p = { class: "px-1.5 py-px text-left" }, g = {
  key: 0,
  class: "text-xs ct-text-4"
};
function y(n, o, e, S, C, B) {
  const i = u("CheckIcon");
  return t(), r("div", p, [
    s("button", {
      type: "button",
      class: a(["ct-dropdown-item group w-full py-[9px] px-2.5 flex items-center space-x-3 rounded-md hover:ct-bg-1", {
        "bg-gray-50 dark:bg-neutral-800": e.isSelected,
        "is-danger": e.isDanger
      }])
    }, [
      s("div", {
        class: a(["flex-1 flex items-center space-x-2 text-sm font-medium text-left", {
          "text-gray-800 dark:text-neutral-200": e.isSelected,
          "ct-text-error": e.isDanger,
          "ct-text-2 group-hover:ct-text-2--hover": !e.isSelected && !e.isDanger
        }])
      }, [
        d(n.$slots, "default")
      ], 2),
      e.value ? (t(), r("p", g, f(e.value), 1)) : l("", !0),
      e.isSelected ? (t(), m(i, {
        key: 1,
        class: "h-5 w-5 ct-fg-1"
      })) : l("", !0)
    ], 2)
  ]);
}
const N = /* @__PURE__ */ c(x, [["render", y]]), h = {}, b = { class: "py-1 ct-bg-1--alt rounded-lg border ct-border-2" };
function k(n, o) {
  return t(), r("div", b, [
    d(n.$slots, "default")
  ]);
}
const V = /* @__PURE__ */ c(h, [["render", k]]), v = {}, D = { class: "py-1" };
function w(n, o) {
  return t(), r("div", D, o[0] || (o[0] = [
    s("span", { class: "w-full h-px bg-gray-200 dark:bg-neutral-800 block" }, null, -1)
  ]));
}
const z = /* @__PURE__ */ c(v, [["render", w]]);
export {
  N as D,
  V as a,
  z as b
};
